var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"p-5",attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":2}}),_c('el-col',{staticClass:"head_title_zone",attrs:{"span":24}},[_c('span',{staticClass:"head_title"},[_vm._v(_vm._s(_vm.currentRoute))])]),_c('el-col',{attrs:{"span":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }